import { useState } from "react";

import {
    FeatureCreateOption,
    FeatureCreateOptionArea,
    FeatureCreateOptionEcologicalFunction,
    FeatureCreateOptionNone,
    FeatureCreateOptionObservation,
    FeatureCreateOptionOther,
} from "../components/types";

export type FeatureCreateOptionDraft =
    | Partial<FeatureCreateOptionArea>
    | Partial<FeatureCreateOptionObservation>
    | Partial<FeatureCreateOptionOther>
    | Partial<FeatureCreateOptionNone>
    | Partial<FeatureCreateOptionEcologicalFunction>;

type UseFeatureCreateDialogParams = {
    open: boolean;
    initialOption?: FeatureCreateOption;
};

// we add an extra layer of state so it can be incomplete, validated and be reset back
export function useDraftSelectedOption({ initialOption }: UseFeatureCreateDialogParams) {
    const [draftSelectedOption, setDraftSelectedOption] = useState<FeatureCreateOptionDraft>(
        () => initialOption ?? { type: "none" },
    );

    const isValid = validate(draftSelectedOption);

    return {
        draftSelectedOption,
        setDraftSelectedOption,
        isValid,
        validate,
    };
}

function validate(draft: FeatureCreateOptionDraft): draft is FeatureCreateOption {
    if (draft.type === "area") {
        return draft.geometryType !== undefined;
    }

    if (draft.type === "observation") {
        return draft.observationType !== undefined && draft.researchType !== undefined && draft.species !== undefined;
    }

    if (draft.type === "ecologicalFunction") {
        return draft.species !== undefined && draft.researchType !== undefined && draft.ecologicalFunctionType !== undefined;
    }

    if (draft.type === "other") {
        return draft.geometryType !== undefined;
    }

    return false;
}
